import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import heroImg from '../images/hero-cloud.png';
import { commonStyles } from "../pages/commonStyles";

const Hero = () => {
    return (
        <>
            <div className="hero" id='hero'>
             

               <div className="overflow-hidden mt-8 lg:mt-4 py-2" data-aos="zoom-in">
<div className="max-w-7xl mx-auto px-4 lg:px-8">
                   <div
  id="hero"
 className="flex flex-col lg:flex-row items-center justify-between gap-16 py-16"
>
                       <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left lg:pr-12" data-aos="zoom-in" data-aos-delay="200">
                         <h1 className={`${commonStyles.heading} mb-6`}>
                                {/* We build digital solutions to help businesses scale */}
                                Welcome to <span>Quadprosoft Technologies</span>
                            </h1>
                           <div className={`${commonStyles.paragraph} mb-4`}>We understand that the key to profitability in an increasingly
                                competitive and complicated market is the ability to fluidly
                                deploy resources to address precise business and technological
                                challenges.</div>
                            <div className="mb-4 space-x-0 md:space-x-2 md:mb-8">
                                <Link to="/about"className="inline-flex items-center justify-center px-8 py-4 bg-blue-900 hover:bg-blue-500 text-white text-lg font-semibold rounded-xl shadow-lg transition-all duration-300 hover:scale-105">
                                    Learn more
                                    <svg className="w-5 h-5 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </Link>
                                {/* <Link to="/contact" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0">
                                    Get Started
                                    <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                </Link> */}
                                {/* <a href="#_" className="inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg text-white bg-gray-500 hover:bg-gray-400 shadow-xl rounded-2xl sm:w-auto sm:mb-0">
                                    Learn More
                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path></svg>
                                </a> */}
                                
                            </div>
                        </div>
<div className="w-full lg:w-[50%] flex justify-center lg:-translate-x-10">
  <img
  src={heroImg}
  alt="Quadprosoft Technologies"
  className="w-[105%] max-w-none h-auto object-contain lg:-translate-x-10"
/>
</div>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}

export default Hero;